
import { CSS } from "@dnd-kit/utilities";
import { faAlignJustify, faEdit, faPen, faPlus, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { DndContext, KeyboardSensor, PointerSensor, closestCorners, useDroppable, useSensor, useSensors } from "@dnd-kit/core";
import { ContainerField } from "./ContainerField";

const rutaImg = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + process.env.REACT_APP_IMAGENES


export function SortableField(props) {
    const [mostarBotones, setMostarBotones] = useState(false)
    const { id, index, field, handleMostrarModal, removerChildren, removerPadre, anadirHijos, editarChildren, handleDragEnd } = props;

    const { type, styles } = field;

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({
        id
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        width: styles?.width === 0 ? '' : styles?.width ? styles?.width : '100%',
        height: styles?.height === 0 ? '' : styles?.height ? styles?.height : '100%',
        background: styles?.background,
        backgroundImage: styles.backgroundUrl && `url(${rutaImg + styles.backgroundUrl})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        paddingTop: styles?.paddingArriba,
        paddingBottom: styles?.paddingAbajo,
        paddingLeft: styles?.paddingIzquierda,
        paddingRight: styles?.paddingDerecha,
        marginTop: styles?.marginArriba,
        marginBottom: styles?.marginAbajo,
        marginLeft: styles?.marginIzquierda,
        marginRight: styles?.marginDerecha,
        borderRadius: styles?.borderRadius ? `${styles?.borderRadius}px` : ''
    };

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    return (
        <div ref={setNodeRef} style={style} onMouseEnter={() => setMostarBotones(true)} onMouseLeave={() => setMostarBotones(false)} className={`canvas-container  ${styles?.className}`} >

            {mostarBotones && (<div className="botones-utiles-container">

                <div className="botones-utiles boton-cabecera ">
                    <button className="botones-utiles-remover" onClick={() => editarChildren({ id, type, styles })}><FontAwesomeIcon icon={faPen} size="lg" /></button>
                    <button  {...listeners} {...attributes}><FontAwesomeIcon icon={faAlignJustify} size="lg" /></button>
                    <button className="botones-utiles-remover"><FontAwesomeIcon icon={faPlus} size="lg" onClick={() => anadirHijos(id)} /></button>
                    <button className="botones-utiles-remover"><FontAwesomeIcon icon={faX} size="lg" onClick={() => removerChildren(id)} /></button>
                </div>

            </div>)}
            <DndContext
                sensors={sensors}
                collisionDetection={closestCorners}
                onDragEnd={handleDragEnd}
            >
                <SortableContext
                    id={id}
                    items={field?.fields}
                    strategy={verticalListSortingStrategy}
                >

                    {field?.fields?.map((f, i) => (
                        <ContainerField key={f.id} id={f.id} field={f} index={i} indexPadre={index} anadirHijos={anadirHijos} editarChildren={editarChildren} handleMostrarModal={handleMostrarModal} removerChildren={removerChildren} removerPadre={removerPadre} handleDragEnd={handleDragEnd} />
                    ))}

                </SortableContext>
            </DndContext>

        </div>
    );
}
